/* unplugin-vue-components disabled */import script from "./articleRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./articleRecord.vue?vue&type=script&setup=true&lang=js"

import "./articleRecord.vue?vue&type=style&index=0&id=45ffb508&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ffb508"]])

export default __exports__